export enum RemunerationEnum {
  indiciaire = 1,
  horaire = 2
}
